const validate = (value, minValue) => {
  // let another rule check if value is numeric or not !
  if (isNaN(value)) {
    return true
  }

  let parsedValue = parseInt(value)
  let parsedMinValue = parseInt(minValue)
  if (parsedValue < parsedMinValue) {
    return false
  }

  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return `The value must be greater than $ {minValue}`
  }
}
